module.exports = __webpack_public_path__ + "media/images/iconSocialMail-d53d548855630b981dfc8892f6706a55.png";